import { useUnifyAdminStore } from '../../AdminStore';
import { FileUploader } from "react-drag-drop-files";
import * as StyledComponents from '../StyledComponents';
import * as XLSX from "xlsx";
import { Button, BUTTON_VARIANTS } from 'cdk-radial';
import get from 'lodash/get';
import { t } from 'i18next';

export const OutageBrowseOrDragBulkUpload = (): JSX.Element => {

    const sideSheetData = useUnifyAdminStore(
        (state) => state.productOutageSideSheetData
    );

    const updateOutageSideSheetData = useUnifyAdminStore(
        (state) => state.updateProductOutageSideSheetData
    );

    const setOutageShowToastState = useUnifyAdminStore(
        (state) => state.setProductOutageShowToastState
      );

    const fileTypes = ["xlsx", "xls"];

    const uploadedEnterprises = get(sideSheetData, 'uploadedEnterprises');
    const uploadedStores = get(sideSheetData, 'uploadedStores');
    const uploadedCNumbers = get(sideSheetData, 'uploadedCNumbers');

    const handleUpload = async (file: any) => {
        try {
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data, { type: "array" });

            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (jsonData.length > 3000) {
                setOutageShowToastState(t('bulkUpload.tooManyRows'), 'Error');
                return;
            }

            const isSingleColumn = jsonData.every((row: any) => row.length === 1);
            if (!isSingleColumn) {
                throw new Error("The file should contain only one column.");
            }

            const values = jsonData.map((row: any) => row[0]).join(",");

            if (values.trim().startsWith('E')) {
                updateOutageSideSheetData({
                    fieldName: 'uploadedEnterprises',
                    value: values,
                });
                updateOutageSideSheetData({
                    fieldName: 'targetEnterprises',
                    value: values,
                });
                if (uploadedCNumbers === undefined) {
                    updateOutageSideSheetData({
                        fieldName: 'uploadedCNumbers',
                        value: '',
                    });
                }
           
                if (uploadedStores === undefined) {
                    updateOutageSideSheetData({
                        fieldName: 'uploadedStores',
                        value: '',
                    });
                }
            }
            else if (values.trim().startsWith('C')) {
                updateOutageSideSheetData({
                    fieldName: 'uploadedCNumbers',
                    value: values,
                });
                updateOutageSideSheetData({
                    fieldName: 'targetCNumbers',
                    value: values,
                });
                if (uploadedEnterprises === undefined) {
                    updateOutageSideSheetData({
                        fieldName: 'uploadedEnterprises',
                        value: '',
                    });
                }
                if (uploadedStores === undefined) {
                    updateOutageSideSheetData({
                        fieldName: 'uploadedStores',
                        value: '',
                    });
                }
            }
            else if (values.trim().startsWith('S')) {
                updateOutageSideSheetData({
                    fieldName: 'uploadedStores',
                    value: values,
                });
                updateOutageSideSheetData({
                    fieldName: 'targetStores',
                    value: values,
                });
              
                if (uploadedEnterprises === undefined) {
                    updateOutageSideSheetData({
                        fieldName: 'uploadedEnterprises',
                        value: '',
                    });
                }
                if (uploadedCNumbers === undefined) {
                    updateOutageSideSheetData({
                        fieldName: 'uploadedCNumbers',
                        value: '',
                    });
                }
            }

        }
        catch (error: any) {
            console.error("Error processing file:", error.message);
        }
    };

    const viewData = () => {
        updateOutageSideSheetData({
            fieldName: 'showFileData',
            value: true,
        });

        
    }

    return (
        <div style={{ width: '95%', paddingTop: '15px'}}>
            {((uploadedCNumbers && uploadedCNumbers.length > 0) || (uploadedEnterprises && uploadedEnterprises.length > 0) || (uploadedStores && uploadedStores.length > 0)) && <div style={{ display: 'ruby', height: '20px' }}>
                <p style={{ fontSize: "14px" }}>
                    {t('bulkUpload.fileUploaded')} | </p>
                <Button text={t('bulkUpload.viewData')} style={{ color: "#006CFA" }} onClick={viewData} variant={BUTTON_VARIANTS.TEXT} ></Button></div>}
            <FileUploader handleChange={handleUpload} name="file" types={fileTypes} style={{ width: '100%' }}>
                <StyledComponents.StyleduploaderContainer>
                    <StyledComponents.FileUpload></StyledComponents.FileUpload>
                    <p style={{ fontSize: "14px", paddingTop: '20px' }}>
                        {t('bulkUpload.dragText')} <span style={{ color: "#006CFA" }}>{t('bulkUpload.browseText')}</span>
                    </p>
                </StyledComponents.StyleduploaderContainer>
            </FileUploader>
        </div>
    );
};
